export default {"src":"__ASTRO_ASSET_IMAGE__C1Jt6WrV__","width":125,"height":35,"format":"svg"}